export default "__VITE_ASSET__7ea94ab6__"